import { animate, style, transition, state, trigger, group, query } from '@angular/animations';

export let Animations = {
  SlideInRight: trigger('slideInRight', [
    transition(':enter', [style({ left: '-330px' }), animate('.2s ease-out', style({ left: '80px' }))]),
    transition(':leave', [animate('.3s ease', style({ left: '-330px' }))])
  ]),
  FadeInOut: trigger('fadeInOut', [
    state('void', style({ opacity: 0 })),
    transition(':enter', [style({ opacity: '0' }), animate('.15s 150ms', style({ opacity: '1' }))]),
    transition(':leave', [style({ opacity: '1' }), animate('.15s', style({ opacity: '0' }))])
  ]),
  PopUpDown: trigger('popUpDown', [
    transition(':enter', [style({ bottom: '-500px' }), animate('.3s ease-out', style({ bottom: '13px' }))]),
    transition(':leave', [style({ bottom: '13px' }), animate('.3s', style({ bottom: '-500px' }))])
  ]),
  ShrinkOut: trigger('shrinkOut', [transition(':leave', [style({ height: '101px' }), animate('.2s ease', style({ height: 0 }))])]),
  SlideUpFull: trigger('slideUpFull', [
    transition('* => *', [
      group([
        query(':enter', [style({ top: '100vh' }), animate('.25s ease-out', style({ top: '0' }))], { optional: true }),
        query(':leave', [style({ top: '0' }), animate('.25s ease-out', style({ top: '100vh' }))], { optional: true })
      ])
    ])
  ])
};
